module.exports = __webpack_public_path__ + "static/media/penguins.cde82fdf.jpg";